import { render, staticRenderFns } from "./AthleteComparativeDataPerformanceSummary.vue?vue&type=template&id=4da63b10&scoped=true&"
import script from "./AthleteComparativeDataPerformanceSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataPerformanceSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataPerformanceSummary.vue?vue&type=style&index=0&id=4da63b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da63b10",
  null
  
)

export default component.exports